import msisdnGuard from '@/router/middlewares/msisdnGuard';
import store from '@/store';
import {EnrichedEnum} from '@/core/customer';

export default function technologyUpdateFlowGuard(to, from, next) {
  if (store.state.customer.enriched === EnrichedEnum.ENRICHED) {
    msisdnGuard(to, from, next);
  } else {
    next({name: 'notfound'});
  }
}
